package com.kaihuoy.components.common

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.kaihuoy.components.common.*
import kotlinx.browser.window
import kotlin.js.Date


@Composable
fun TopBar(greeting: String, onLogout: () -> Unit) {
    var hovered by remember { mutableStateOf(false) }
    var screenWidth by remember { mutableStateOf(window.innerWidth) }
    DisposableEffect(Unit) {
        val callback = { _: dynamic ->
            screenWidth = window.innerWidth
        }
        window.addEventListener("resize", callback)
        onDispose {
            window.removeEventListener("resize", callback)
        }
    }

    val isMobile = screenWidth <= 600
    Div(attrs = {
        style {
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.SpaceBetween)
            alignItems(AlignItems.Center)
            padding(if (isMobile) 12.px else 16.px, if (isMobile) 12.px else 32.px)
            minHeight(if (isMobile) 60.px else 80.px)
            property("box-sizing", "border-box")
            width(100.percent)
            property("margin", "0px 0px 5px 0px")
            property("background", KaihuTheme.TopBarGradient)
            borderRadius(if (isMobile) 12.px else 20.px)
            property("border-bottom", "4px solid ${KaihuTheme.Border}")
            property("border-top", "4px solid ${KaihuTheme.Border}")
        }
    }) {
        Div(attrs = { style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column) } }) {
            Span(attrs = {
                id("topbar-date")
                style { fontSize(0.8.em); color(KaihuTheme.TextLight); property("letter-spacing", "0.1em") }
            }) {
                Text(Date().toLocaleDateString("fi-FI"))
            }
            H2(attrs = { style { margin(0.px); color(KaihuTheme.TextPrimary); fontWeight("800"); fontSize(1.2.em) } }) {
                Text(greeting)
            }
        }
        LogOutButton("Kirjaudu ulos", onClick = onLogout, backgroundColor = KaihuTheme.CardBackground)
    }
}
@Composable
fun DashboardCard(
    title: String,
    subtitle: String,
    icon: String,
    containerColor: CSSColorValue,
    onClick: () -> Unit
) {
    var isHovered by remember { mutableStateOf(false) }

    Div(
        attrs = {
            onMouseEnter { isHovered = true }
            onMouseLeave { isHovered = false }
            onClick { onClick() }
            style {
                width(100.percent)
                height(180.px)
                borderRadius(24.px)
                backgroundColor(containerColor)
                color(Color.white)
                padding(32.px)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Row)
                alignItems(AlignItems.Center)
                cursor("pointer")
                property("transition", "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)")
                boxSizing("border-box")
                position(Position.Relative)
                overflow("hidden")
                
                property("box-shadow", if (isHovered) KaihuTheme.ShadowLg else KaihuTheme.ShadowMd)
                
                if (isHovered) {
                    property("transform", "translateY(-6px) scale(1.02)")
                    property("filter", "brightness(1.05)")
                }
            }
        }
    ) {
        // Taustakoriste (iso ikoni haalistuneena)
        Div(attrs = {
            style {
                position(Position.Absolute)
                right((-10).px)
                bottom((-50).px)
                fontSize(7.em)
                opacity(0.15)
                property("pointer-events", "none")
                property("transition", "all 0.4s ease")
                if (isHovered) {
                    property("transform", "rotate(-30deg) scale(1.1)")
                }
            }
        }) {
            TIcon(icon, 7.em)
        }

        Div(attrs = { style { flexGrow(1); position(Position.Relative); property("z-index", "1") } }) {
            Div(attrs = {
                style {
                    fontSize(2.5.em)
                    marginBottom(16.px)
                }
            }) {
                TIcon(icon)
            }

            H3(attrs = {
                style {
                    margin(0.px)
                    fontSize(1.4.em)
                    fontWeight("700")
                    lineHeight("1.2")
                }
            }) { Text(title) }

            P(attrs = {
                style {
                    margin(8.px, 0.px, 0.px, 0.px)
                    fontSize(0.9.em)
                    fontWeight("400")
                    opacity(0.9)
                }
            }) { Text(subtitle) }
        }
    }
}